export const ENTRY_ZENDESK_HOST = {
  link: "https://entryllc.zendesk.com",
  name: "EntryLLC",
};

export const TRAVELASSIST_ZENDESK_HOST = {
  link: "https://travelassist.zendesk.com",
  name: "Travelassist",
};

export const DEFAULT_ZENDESK_HOST = ENTRY_ZENDESK_HOST.link;

export const ZENDESK_HOSTS = [
  TRAVELASSIST_ZENDESK_HOST,
  ENTRY_ZENDESK_HOST,
];

export const getZendeskNameByUrl = (url) => {
  return ZENDESK_HOSTS.find((zdHost) => zdHost.link === url)?.name || "";
};
